<div class="modal-header">
  <h1 class="modal-title float-start">{{ "demo.educationalMaterial.userReviews.modal.title" | translate }}</h1>

  <button
    type="button"
    class="btn-close float-end"
    [attr.aria-label]="'forms.common.close' | translate"
    (click)="bsModalRef.hide()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="ratingContent">{{ "demo.educationalMaterial.userReviews.ratingContent" | translate }} (1-5)</label>

      <input
        type="number"
        class="form-control"
        id="ratingContent"
        formControlName="ratingContent"
        min="1"
        max="5"
        step="1"
        [ngClass]="{ 'is-invalid': ratingContentCtrl.errors }" />

      @if (ratingContentCtrl.errors) {
        <div class="invalid-feedback">
          @if (ratingContentCtrl.errors.min) {
            <div>
              {{ "forms.common.min" | translate }} {{ ratingContentCtrl.errors.min.min }}
            </div>
          }
          @if (ratingContentCtrl.errors.max) {
            <div>
              {{ "forms.common.max" | translate }} {{ ratingContentCtrl.errors.max.max }}
            </div>
          }
        </div>
      }
    </div>

    <div class="form-group">
      <label for="ratingVisual">{{ "demo.educationalMaterial.userReviews.ratingVisual" | translate }} (1-5)</label>

      <input
        type="number"
        class="form-control"
        id="ratingVisual"
        formControlName="ratingVisual"
        min="1"
        max="5"
        step="1"
        [ngClass]="{ 'is-invalid': ratingVisualCtrl.errors }" />

      @if (ratingVisualCtrl.errors) {
        <div class="invalid-feedback">
          @if (ratingVisualCtrl.errors.min) {
            <div>
              {{ "forms.common.min" | translate }} {{ ratingVisualCtrl.errors.min.min }}
            </div>
          }
          @if (ratingVisualCtrl.errors.max) {
            <div>
              {{ "forms.common.max" | translate }} {{ ratingVisualCtrl.errors.max.max }}
            </div>
          }
        </div>
      }
    </div>

    <div class="form-group">
      <label for="feedbackPositive">{{ "demo.educationalMaterial.userReviews.feedbackPositive" | translate }}</label>

      <textarea
        class="form-control"
        id="feedbackPositive"
        formControlName="feedbackPositive"
      [ngClass]="{ 'is-invalid': feedbackPositiveCtrl.errors }"></textarea>

      @if (feedbackPositiveCtrl.errors) {
        <div class="invalid-feedback">
          @if (feedbackPositiveCtrl.errors.maxlength) {
            <div>
              {{ feedbackPositiveCtrl.errors.maxlength.actualLength }} / {{
              feedbackPositiveCtrl.errors.maxlength.requiredLength }}
            </div>
          }
        </div>
      }
    </div>

    <div class="form-group">
      <label for="feedbackSuggest">{{ "demo.educationalMaterial.userReviews.feedbackSuggest" | translate }}</label>

      <textarea
        class="form-control"
        id="feedbackSuggest"
        formControlName="feedbackSuggest"
      [ngClass]="{ 'is-invalid': feedbackSuggestCtrl.errors }"></textarea>

      @if (feedbackSuggestCtrl.errors) {
        <div class="invalid-feedback">
          @if (feedbackSuggestCtrl.errors.maxlength) {
            <div>
              {{ feedbackSuggestCtrl.errors.maxlength.actualLength }} / {{
              feedbackSuggestCtrl.errors.maxlength.requiredLength }}
            </div>
          }
        </div>
      }
    </div>

    <div class="form-group">
      <label for="feedbackPurpose">{{ "demo.educationalMaterial.userReviews.feedbackPurpose" | translate }}</label>

      <textarea
        class="form-control"
        id="feedbackPurpose"
        formControlName="feedbackPurpose"
      [ngClass]="{ 'is-invalid': feedbackPurposeCtrl.errors }"></textarea>

      @if (feedbackPurposeCtrl.errors) {
        <div class="invalid-feedback">
          @if (feedbackPurposeCtrl.errors.maxlength) {
            <div>
              {{ feedbackPurposeCtrl.errors.maxlength.actualLength }} / {{
              feedbackPurposeCtrl.errors.maxlength.requiredLength }}
            </div>
          }
        </div>
      }
    </div>

    <button
      type="button"
      class="btn btn-gray"
      [attr.aria-label]="'forms.common.cancel' | translate"
      (click)="bsModalRef.hide()">
      {{ "forms.common.cancel" | translate }}
    </button>

    <button type="submit" class="btn btn-blue">{{ "forms.common.save" | translate }}</button>
  </form>
</div>
